export const zindex = {
  top: 3,
  middle: 2,
  bottom: 1,
};
